/**
 * React Flow Suggested Style for Edge Labels
 * to center the label on the edge
 */
export function defaultEdgeLabelStyle({
  labelX,
  labelY,
}: {
  labelX: number;
  labelY: number;
}): React.CSSProperties {
  return {
    position: 'absolute',
    transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
    pointerEvents: 'all',
  };
}
